import { createContext, useContext, useEffect, useRef, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";
import api from "../api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const hasFetched = useRef(false); // 👈 outside useEffect

  useEffect(() => {
    console.log("AuthContext mounted");
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        if (hasFetched.current) return;
        hasFetched.current = true;

        try {
          const res = await api.get("/auth/me");
          localStorage.setItem("user", JSON.stringify(res.data));
          setUser(res.data);
        } catch (err) {
          console.error("AuthContext error:", err);
          await auth.signOut();
          setUser(null);
        }
      } else {
        hasFetched.current = false;
        localStorage.removeItem("user");
        setUser(null);
      }

      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
